var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"header-cell",class:_vm.cellCssClasses,attrs:{"scope":"col"},on:{"click":_vm.onSortClicked}},[_vm._t("default"),(_vm.sortable)?_c('span',[_c('i',{staticClass:"fa",class:_vm.sortDirection})]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }